export class AssertError extends Error {}

export function isNonEmptyString(value: unknown): value is string {
  return typeof value === 'string' && !!value.length;
}

export function isStringOrUndefined(value: unknown): value is string | undefined {
  return value === undefined || typeof value === 'string';
}

export function isArrayOfNonEmptyStrings(value: unknown): value is string[] {
  return Array.isArray(value) && value.every(isNonEmptyString);
}

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export function assertNonEmptyString(value: unknown, variableName: string): asserts value is string {
  if (!isNonEmptyString(value)) {
    throw new AssertError(`'${variableName}' is expected to be a nonempty string`);
  }
}

export function assertEmptyOrString(value: unknown, variableName: string): asserts value is string | undefined {
  if (!isStringOrUndefined(value)) {
    throw new AssertError(`'${variableName}' is expected to be a string or undefined`);
  }
}

export function assertIsArray(value: unknown, variableName: string): asserts value is unknown[] {
  if (!Array.isArray(value)) {
    throw new AssertError(`'${variableName}' is expected to be an array`);
  }
}

export function assertArrayOfNonEmptyStrings(value: unknown, variableName: string): asserts value is string[] {
  if (!isArrayOfNonEmptyStrings(value)) {
    throw new AssertError(`'${variableName}' is expected to be an array of nonempty strings`);
  }
}

export function assertRecord(value: unknown, variableName: string): asserts value is Record<string, unknown> {
  if (!isRecord(value)) {
    throw new AssertError(`'${variableName}' is expected to be an object of type Record`);
  }
}
